import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalModule } from 'ngx-bootstrap/modal';
import { MomentModule } from 'angular2-moment';
import { NgSlimScrollModule } from "../../../node_modules/ngx-slimscroll/src/ngx-slimscroll/module/ngx-slimscroll.module";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BusyModule } from 'angular2-busy';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { UiSwitchModule } from 'ngx-ui-switch';

import { BrightServeModule } from "app/brightserve/brightserve.module";
import { AuthGuard } from "app/brightserve/auth-guard";
import { SharedModule } from "app/shared/shared.module";

//client list
import { ClientsListComponent } from './list/clients-list.component';

//client detail
import { ClientsDetailComponent } from './details/clients-detail.component';

import { ClientDetailInformationComponent } from './details/information/client-detail-information.component';
import { ClientDetailInventoryComponent } from './details/inventory/client-detail-inventory.component';

import { ClientsService } from 'app/clients/clients.service';

const ClientsRoutes: Routes = [
    { path: 'clients', component: ClientsListComponent, canActivate: [AuthGuard] },
    { path: 'client/:id', component: ClientsDetailComponent, children: [
        { path: '', redirectTo: 'information', pathMatch: 'full' },
        { path: 'information', component: ClientDetailInformationComponent },
        { path: 'inventory', component: ClientDetailInventoryComponent }
    ], canActivate: [AuthGuard] }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(ClientsRoutes),
        NgbModule,
        ModalModule,
        MomentModule,
        BrightServeModule,
        SharedModule,
        NgSlimScrollModule,
        InfiniteScrollModule,
        BusyModule,
        BsDatepickerModule.forRoot(),
        UiSwitchModule
    ],
    declarations: [
        ClientsListComponent,
        ClientsDetailComponent,
        ClientDetailInformationComponent,
        ClientDetailInventoryComponent
    ],
    providers: [
        ClientsService
    ]
})
export class ClientsModule { }




// WEBPACK FOOTER //
// ./src/app/clients/clients.module.ts